import { CcbDataType, CcbFormatItem, FieldsType } from "./types";

export const convertCCbData = (
  ccbFormat: CcbFormatItem[],
  ccbFields: FieldsType
): CcbDataType[] => {
  const formatValue = (value: unknown) => {
    // данные вида "true" - выводим как есть
    if (typeof value === "boolean") {
      return String(value);
    }

    if (!value) {
      return "";
    }

    return value;
  };

  return ccbFormat.map(({ name, desc, fields: nestedFields }) => {
    // условие наличия вложенного массива
    const isNestedFields = nestedFields && Array.isArray(nestedFields);

    const ccbValue = ccbFields[name] || "";
    const isCcbValueArray = Array.isArray(ccbValue);

    if (isCcbValueArray && isNestedFields) {
      const value = ccbValue.map((ccbValueItem) =>
        convertCCbData(nestedFields, ccbValueItem as FieldsType)
      );

      return {
        description: desc,
        value: formatValue(value),
      };
    }

    return {
      description: desc,
      value: formatValue(
        isNestedFields
          ? convertCCbData(nestedFields, ccbValue as FieldsType)
          : ccbValue
      ),
    };
  });
};
